<template>
  <div class="form-finance part-finance-container">
    <div class="form-rows">
      <!-- 财务 -->
      <div class="card-title" style="margin-top: 20px;">
        <el-link @click="loadFinanceAccount">财务</el-link>
      </div>

      <div class="formCard" v-loading="loading">
        <div v-if="userAuth.can_see_artist_info_col_rate&&showDivide">
          <div class="card-title" style="margin-top: 20px;">
            分成信息
          </div>
          <div class="formCard">
            <div>
              <el-form :inline="true" :model="rateFormData" size="mini">
                <el-form-item label="实际所得" prop="rate">
                  <span class="input-val">{{ moneyFormat(rateFormData.real_income || 0) }}</span>
                  <el-popover placement="top" width="500" trigger="click" style="float: right">
                    <algorithm-list :colSpan="24" :propsAlgorithm="[algorithm[0]]"></algorithm-list>
                    <el-button type="text" icon="el-icon-info" style="font-size: 1em"
                               slot="reference"></el-button>
                  </el-popover>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="rateFormData.share_mode" placeholder="请选择分成方式">
                    <el-option v-for="(item,key) in share_mode" :key="key" :value="item.value" :label="item.label"/>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="rateFormData.share_mode===share_mode[0].value" prop="rate">
                  <el-input class="el-input-c"
                            v-model="rateFormData.rate"
                            placeholder="请输入分成比例（%）"
                            oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                            @change="calcIncome"
                            v-if="editField==='rate'||!rateFormData.rate"
                            style="width: 220px"
                            @blur="clearEditField"
                            clearable>
                    <template slot="append">%</template>
                  </el-input>
                  <div style="display: flex;flex-direction: row;gap: 5px;justify-content: space-between" v-else>
                    <div class="input-val" @click="selectEditField('rate')">
                      <span class="rate">{{ rateFormData.rate || '--' }}</span>
                    </div>
                    <el-tooltip content="查看分成比例设置" placement="bottom" effect="light">
                      <el-link icon="el-icon-setting" type="primary" @click="showRateList"></el-link>
                    </el-tooltip>

                  </div>
                </el-form-item>
                <el-form-item label="红人所得（￥）" prop="artist_income">
                  <el-tooltip slot="label"
                              content="红人所得 =（执行价 - 返点金额 + 授权价 + 购物车费用 + 微任务所得）× 分成比例"
                              placement="top">
                    <span>红人所得（￥）</span>
                  </el-tooltip>
                  <el-input class="el-input-c"
                            v-model="rateFormData.artist_income"
                            placeholder="请输入红人所得（￥）"
                            clearable
                            oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                            @focus="selectEditField('artist_income')"
                            v-if="editField==='artist_income'||!rateFormData.artist_income"
                            style="width: 220px"
                            @change="calcCompanyIncome"
                            @blur="clearEditField"
                  >
                    <template slot="append">元</template>
                  </el-input>
                  <div class="input-val" @click="selectEditField('artist_income')" v-else>
                    <span class="artist_income">{{ rateFormData.artist_income || '--' }}</span>
                  </div>
                </el-form-item>
                <el-form-item label="公司所得（￥）"
                              prop="company_income">
                  <el-tooltip slot="label"
                              content="公司所得 =（执行价 - 返点金额 + 授权价 + 购物车费用 + 微任务所得）×（1 - 分成比例）"
                              placement="top">
                    <span>公司所得（￥）</span>
                  </el-tooltip>
                  <el-input class="el-input-c"
                            v-model="rateFormData.company_income"
                            placeholder="请输入公司所得（￥）"
                            clearable
                            oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                            @focus="selectEditField('company_income')"
                            v-if="editField==='company_income'||!rateFormData.company_income"
                            style="width: 220px"
                            @change="calcArtistIncome"
                            @blur="clearEditField"
                  >
                    <template slot="append">元</template>
                  </el-input>
                  <div class="input-val" @click="selectEditField('company_income')" v-else>
                    <span class="artist_income">{{ rateFormData.company_income || '--' }}</span>
                  </div>
                  <!--                <el-input class="el-input-c" v-model="rateFormData.company_income" placeholder="请输入公司所得"-->
                  <!--                          oninput="value=value.replace(/[^\d^\.^\-]/g,'')" @change="calcArtistIncome" clearable>-->
                  <!--                  <template slot="append">元</template>-->
                  <!--                </el-input>-->
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveOrderRate" :disabled="loadingSubmit"
                             :loading="loadingSubmit">
                    保存分成
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="showRate" class="setting-box" :style="`top:${boxPosition.top};left:${boxPosition.left}`">
              <div style="float: right;margin-right: 10px;font-size: 1.3em" @click="showRateList"><span
                  class="el-icon-close"></span></div>
              <div style="text-align: center">
                <el-link style="font-size: 1.6em;font-weight: bold" type="primary" @click="editRate()">
                  分成设置<span class="el-icon-edit-outline"></span>
                </el-link>
              </div>
              <div style="display: flex;flex-direction: row;gap: 5px;flex-wrap: wrap">
                <div class="artist-info">{{ this.formData.order.artist_name || '' }}</div>
                <div>
                  <div v-if="this.formData.order.platforms" class="platform-info">
                    <!--                      <span style="font-size: 14px;">发布平台：</span>-->
                    <el-tag size="mini" effect="plain" v-for="(platform) in this.formData.order.platforms"
                            :key="platform">{{ platform }}
                    </el-tag>
                  </div>
                </div>
              </div>
              <div class="default-table">
                <el-table :data="rateMapArr">
                  <el-table-column label="平台" prop="platform" align="center" min-width="120"></el-table-column>
                  <el-table-column label="分成比例" prop="rate" align="center" min-width="160"></el-table-column>
                </el-table>
              </div>
              <div class="rate-recommend" @click="showRecommendRate">
                <span>本订单系统推荐分成比例：</span>
                <span class="rate" style="font-size: 1.3em;color: #fe346e">{{ recommendRate || 0 }}</span>
              </div>
              <div class="tip-help">
                订单分成比例规则：<br/>
                1.单平台时，平台有分成比例，取当前平台分成比例；<br/>
                2.单平台时，平台无分成比例，但是关联的平台有，取关联的分成比例；<br/>
                3.单平台时，平台，关联平台都无分成比例，分成比例为0；<br/>
                4.多平台时，平台，关联平台都无分成比例，分成比例为0；<br/>
                5.多平台时，平台，关联平台只有一个分成时，取当前分成；<br/>
                6.多平台时，平台，关联平台有多个分成时，取最大那个分成；<br/>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="card-title" style="margin-top: 20px;">
            回款信息
          </div>
          <div v-if="judgeOrderWholeCase(order,'child')&&!accountList.length" class="formCard">
            全案营销子订单无回款信息
          </div>
          <div v-else class="formCard">
            <div v-if="!judgeOrderWholeCase(order,'child')"
                 style="display: flex;margin-left: 10px;margin-bottom: 8px">
              <div style="margin-right: 20px;">
                结款状态： <span style="color: #FF5722;font-weight: 500">{{
                  order.pay_status_alias || '-'
                }}</span>
              </div>
              <div>
                剩余金额：
                <span style="color: #FF5722;font-weight: 600;font-size: 16px"
                      title="剩余金额 = 含税收入 - 回款金额">{{
                    moneyFormat(order.payment_account - order.sum_amount)
                  }}</span>
              </div>
            </div>
            <div class="default-table" style="width: 80%">
              <el-table :max-height="260" :data="accountList" :row-class-name="rowClassName" show-summary>
                <el-table-column label="序号" prop="index" align="left"
                                 :min-width="50"></el-table-column>
                <el-table-column key="回款时间" label="回款时间" prop="transfer_time" align="left"
                                 :min-width="160"/>
                <el-table-column prop="amount" key="回款金额" label="回款金额" align="left"
                                 :min-width="220">
                  <template slot-scope="scope">
                    {{ moneyFormat(scope.row.amount) }}
                  </template>
                </el-table-column>
                <el-table-column key="收款方式" label="收款方式" prop="pay_term" align="left"
                                 :min-width="120"/>
                <el-table-column key="备注" label="备注" prop="remark" align="left" :min-width="300"
                                 show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.remark || '-' }}
                  </template>
                </el-table-column>
                <el-table-column v-if="userAuth.can_delete_account_record" label="#" align="left"
                                 :min-width="300">
                  <template slot-scope="scope">
                    <el-button v-if="!scope.row.source_id" type="text" size="mini"
                               @click="handelDisAccount(scope.row)">
                      分配
                    </el-button>
                    <el-button type="text" size="mini" @click="handelDelAccount(scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>


        <!-- 合同归档信息 -->
        <part-contract :order-id="orderId" :can-revoke="!order.pid"/>
        <!-- 发票记录 -->
        <InvoiceNumberPanel :order-id="orderId" :is-wcm-child-order="judgeOrderWholeCase(order,'child')"/>
        <!-- 开票记录 -->
        <invoice-records :order-id="orderId"/>
      </div>
    </div>
  </div>

</template>

<script>
import {editOrderRate, getOrderDetailAccount, getOrderRateRecommend} from "@/api/order";
import InvoiceNumberPanel from "@/views/adOrder/components/detail/InvoiceNumberPanel";
import InvoiceRecords from "./InvoiceRecords";
import {judgeOrderWholeCase} from "@/views/adOrder";
import {delAccount, reDistributionAmount} from "@/api/account";
import {algorithm} from "@/views/adOrder/algorithm";
import AlgorithmList from '@/views/adOrder/components/AlgorithmList.vue'
import PartContract from '@/views/adOrder/components/detail/PartContract.vue'
import {getArtistRateList} from "@/api/fboy";

export default {
  name: "PartFinance",
  components: {InvoiceNumberPanel, InvoiceRecords, AlgorithmList, PartContract},
  props: {
    isOperate: {
      type: Number,
      default() {
        return 0
      }
    },
    orderId: {
      type: [Number, String],
      required: true
    },
    showDivide: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
    order() {
      return this.formData.order || {}
    },
    accountList() {
      return this.formData.list || []
    },
    contract() {
      return this.formData.contract || {}
    }
  },
  data() {
    return {
      judgeOrderWholeCase,
      loading: false,
      loadingSubmit: false,
      formData: {
        order: {},
        list: [],
        contract: {}
      },
      rateFormData: {
        id: null,
        real_income: null,
        rate: null,
        artist_income: null,
        company_income: null,
        share_mode: 1
      },
      editField: null,
      share_mode: [
        {label: '分成比例', value: 1},
        {label: '保底金额', value: 2},
      ],
      algorithm,
      rateMapArr: [],
      showRate: false,
      boxPosition: {top: '50%', left: '50%'},
      //建议分成
      recommendRate: 0
    }
  },
  methods: {
    //编辑字段
    selectEditField(field) {
      this.editField = field
    },
    clearEditField() {
      //清空当前编辑字段
      this.editField = null
    },
    moneyFormat(val) {
      return this.gFunc.numberFormat(val, 2, '.', ',', 'round')
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1
      if ((rowIndex % 2) === 1) {
        return 'table-row commonTable-row'
      } else {
        return 'table-row success-row'
      }
    },
    async loadFinanceAccount(is_init = false) {
      this.loading = true
      //获取订单信息 getOrderDetailBase
      let {order, list, contract} = await getOrderDetailAccount({id: this.orderId}).then((res) => {
        return res.model;
      })

      this.rateFormData = {
        id: order.id,
        real_income: order.real_income,
        rate: order.rate,
        artist_income: order.artist_income,
        company_income: order.company_income,
        share_mode: order.exec_share_mode,
      }
      this.formData.order = order
      this.formData.list = list
      this.formData.contract = contract
      this.loading = false
      if (!is_init){
        this.$emit('reload')
      }
    },
    async saveOrderRate() {
      this.$msgbox.confirm(
          `确认保存【分成信息】,分成比例：${this.rateFormData.rate} %，红人所得：${this.rateFormData.artist_income}元，公司所得：${this.rateFormData.company_income} 元 ？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(async () => {
        this.loadingSubmit = true
        let {info} = await editOrderRate(this.rateFormData).then((res) => {
          return res.model;
        })
        if (info) {
          this.showToast({
            title: '提交成功',
            h: this
          })
          await this.loadFinanceAccount()
        }
        this.loadingSubmit = false

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    calcIncome() {
      //计算所得
      this.rateFormData.artist_income = this.rateFormData.rate * this.rateFormData.real_income / 100;
      this.rateFormData.artist_income = this.MathRound(this.rateFormData.artist_income);
      this.rateFormData.company_income = this.rateFormData.real_income - this.rateFormData.artist_income;
      this.rateFormData.company_income = this.MathRound(this.rateFormData.company_income);
    },
    calcCompanyIncome() {
      this.rateFormData.company_income = this.rateFormData.real_income - this.rateFormData.artist_income;
      this.rateFormData.company_income = this.MathRound(this.rateFormData.company_income);

      this.rateFormData.rate = this.MathRound(this.rateFormData.artist_income * 100 / this.rateFormData.real_income);
    },
    calcArtistIncome() {
      this.rateFormData.artist_income = this.rateFormData.real_income - this.rateFormData.company_income;
      this.rateFormData.artist_income = this.MathRound(this.rateFormData.artist_income);
      this.rateFormData.rate = this.MathRound(this.rateFormData.artist_income * 100 / this.rateFormData.real_income);
    },
    MathRound(val) {

      return Math.round(val * 100) / 100;
    },
    handelDisAccount(account) {
      const that = this
      this.$msgbox.confirm(
          `确认分配${account.transfer_time}的【￥${account.amount}】回款记录吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(async () => {

        const response = await reDistributionAmount({id: account.id});
        if (!response.success) {
          that.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
          return;
        }
        that.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
        // 刷新列表
        await that.loadFinanceAccount()
      })
    },
    handelDelAccount(account) {
      const that = this
      this.$msgbox.confirm(
          `确认删除${account.transfer_time}的【￥${account.amount}】回款记录吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(async () => {

        const response = await delAccount({id: account.id});
        if (!response.success) {
          that.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
          return;
        }
        that.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
        // 刷新列表
        await that.loadFinanceAccount()
      })
    },
    //获取红人分成比例记录
    getRateList() {
      getArtistRateList({artist_id: this.formData.order.artist_id}).then((res) => {
        // console.log(res.model.list)
        let list = res.model.list || []
        this.rateMapArr = list || []
      })
    },
    editRate() {
      this.editFBoy(this.formData.order.artist_id)
    },
    showRateList(e) {
      // eslint-disable-next-line no-console
      this.boxPosition.top = e.clientY + 'px'
      this.boxPosition.left = e.clientX + 'px'
      this.showRate = !this.showRate
      if (this.showRate) {
        this.getRateList()
        this.showRecommendRate()

      }
    },
    //编辑红人
    editFBoy(id) {
      const {href} = this.$router.resolve({
        name: `addFBoy`,
        query: {type: "edit", id: id}
      });
      window.open(href, "_blank");
    },
    showRecommendRate() {
      this.recommendRate = 0
      getOrderRateRecommend({order_id: this.formData.order.id}).then((res) => {
        this.recommendRate = res.model.rate || 0
      })
    }

  },
  created() {
    this.loadFinanceAccount(true)
  }

}
</script>

<style lang="scss">
.part-finance-container {
  .card-title {
    position: relative;
    /*padding-top: 24px;*/
    padding-left: 55px;
    margin-bottom: 15px;
    color: rgba(50, 50, 50, 1);
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }

  .card-title::after {
    content: "";
    position: absolute;
    bottom: 6.5px;
    left: calc(55px - 8px - 6px);
    width: 8px;
    height: 8px;
    background: rgba(224, 63, 61, 1);
    border-radius: 2px;

  }

  .formCard {
    padding: 24px 20px;
    border-radius: 6px;
    border: 1px solid rgba(221, 221, 221, 1);
    /*margin-bottom: 16px;*/
    width: 95%;
    margin: 5px auto;
  }

  .form-rows {
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 6px;
    padding: 20px;
  }

  .input-val {
    min-width: 120px;
    width: 200px;
    max-width: 300px;
    overflow-x: hidden;
    /*display: flex;*/
    text-align: center;
    /*border: 1px dashed rebeccapurple;*/
    border: 1px solid rgb(220, 223, 230);
    padding-left: 5px;
    padding-right: 5px;
    line-height: 28px;
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
  }
}

.setting-box {
  background: #fefefe;
  border: #f2f2f2 1px solid;
  width: 420px;
  padding: 10px;
  border-radius: 4px;
  position: fixed;
  transform: translate(10%, -50%);
  //right: 20px;
  //top: 30%;
  //opacity: 1;
  z-index: 999;
}

.artist-info, .platform-info {
  border: #fe346e 1px dashed;
  border-radius: 4px;
  padding: 4px 8px;
}

.artist-info::before {
  content: '红人昵称：';
}

.platform-info::before {
  content: '发布平台：';
}

.rate-recommend {
  padding: 10px;
}

.tip-help {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px 24px;
  overflow-y: auto;
  background-color: #FFF9FBFC;
  //font-family: PingFangSC-Regular;
  font-size: 12px;
  line-height: 22px;
  color: #666;
  border-radius: 9px;
  position: relative;
  box-sizing: border-box;
  //height: 110px;
}
</style>
